import { AbstractValidatedClass, Joi, ValidatedClass, constraint } from '@verclam/form-validator';

export type PasswordForgottenFormArgs = {
	email: string;
};

@ValidatedClass()
class PasswordForgottenFormData extends AbstractValidatedClass<PasswordForgottenFormArgs> {
	@constraint(Joi.string().email({ tlds: false }), () => 'L’adresse e-mail est invalide.')
	@constraint(Joi.string().required(), () => 'L’adresse e-mail est obligatoire.')
	public readonly email: string;

	constructor(data: PasswordForgottenFormArgs) {
		super(data);
		this.email = data.email;
		Object.freeze(this);
	}

	static createEmpty(): PasswordForgottenFormData {
		return new PasswordForgottenFormData({ email: '' });
	}

	setEmail(email: string): this {
		return this.cloneWith({ email } as Partial<PasswordForgottenFormArgs>);
	}
}

export default PasswordForgottenFormData;
